<template>
    <div id="Header">
        <div class="news-tips" style="margin-bottom: -2px;" v-if="false">
          <a href="examine.html" target="_blank">
            <img src="./img/examine_tip.jpg" alt="">
          </a>
        </div>
        <div class="nav">
            <div class="body">
                <div class="left">
                    <div class="login a" v-if="!userName" @click="toLogin">
                        <i @click="status = 0">登录</i>
                        <!-- / <span @click="status = 1">注册</span> -->
                    </div>
                    <div class="login" v-else>
                        您好 <span style="color: #f9513b">{{userName}}</span> <span @click="logOut">[退出]</span>
                    </div>
                    <div class="btn">
                        <a href="javascript:;" @click="goUser">
                            <div class="btn-child">个人中心</div>
                            <div class="tcp">TCP</div>
                        </a>
                        <a href="/user/index.html#/fd_center/fangdan" v-if="userName && (userLlfdType == 2 || userLlfdType == 3)" target="_blank">
                            <div class="btn-child">放单中心</div>
                        </a>
                        <a href="javascript:void(0);" v-if="!userName" @click="login">
                            <div class="btn-child">放单中心</div>
                        </a>
                        <a href="businesEnter.html" target="_blank">
                            <div class="btn-child">淘客入驻</div>
                        </a>

                        <a href="/staticHtml/lshbm/quyu.html" target="_blank" v-if="userName">
                            <div class="btn-child">区域中心</div>
                        </a>
                        <a href="javascript:;" v-if="!userName" @click="login">
                            <div class="btn-child">区域中心</div>
                        </a>

                        <!-- <a href="/staticHtml/lshbm/index.html" target="_blank" v-if="userName">
                            <div class="btn-child">区域中心报名</div>
                        </a>
                        <a href="javascript:;" v-if="!userName" @click="login">
                            <div class="btn-child">区域中心报名</div>
                        </a> -->
                    </div>
                </div>
                <div class="right">
                    <div v-if="userLlfdType != 2" class="right-child" style="margin: 0 10px">美逛系统配置指导：meiguang2021</div>
                    <div v-if="userLlfdType != 2" class="right-child">|</div>
                    <div v-if="userLlfdType != 2" class="right-child" style="margin: 0 10px">微信文案号：youhuigou6868</div>
                    <div v-if="userLlfdType != 2" class="right-child">|</div>
                    <a href="aboutWe.html#/hzLx" target="_blank">
                        <div class="right-child">联系我们</div>
                    </a>
                    <div class="right-child">|</div>
                    <a href="http://help.zutuan.cn/" target="_blank">
                        <div class="right-child">帮助中心</div>
                    </a>
                </div>
            </div>
        </div>
        <template v-if="!isOnlyNav">
          <div id="head">
              <div class="left">

              </div>
              <div class="center">
                  <input type="text" placeholder="    输入关键词或商品链接" v-model="inputValue" @keyup.enter="toSearch">
                  <div class="search" @click="toSearch">
                      <i class="iconfont icon--fangdajing"></i> 搜索
                  </div>

              </div>
              
          </div>
          <nav id="navigation">
              <div class="body">
                  <a href="index.html">
                      <div :class="nav ==1 ? 'child active':'child'">
                          首页
                      </div>
                  </a>
                  <a href="list.html">
                      <div :class="nav ==2 ? 'child active':'child'">
                          <span>&nbsp;&nbsp;&nbsp;</span>实时榜单
                      </div>
                  </a>
                  
                  <!-- <a href="limitedTime.html">
                      <div :class="nav == 7 ? 'child active':'child'">
                          限时抢购
                      </div>
                  </a> -->
                  <!-- <a href="examine.html">
                      <div :class="nav == 8 ? 'child active':'child'">
                          验货专区
                      </div>
                  </a> -->
                  <a href="advance.html">
                      <div :class="nav == 3 ? 'child active':'child'">
                      商品预告
                      </div>
                  </a>
                  <!--<a href="groupCollectQun.html">-->
                  <!--<div :class="nav == 4 ? 'child active':'child'">-->
                  <!--全联盟采集群-->
                  <!--</div>-->
                  <!--</a>-->
                  <a href="materialsTrain.html">
                      <div :class="nav == 5 ? 'child active':'child'">
                          素材培训专区
                      </div>
                  </a>

                  <a href="tools.html">
                      <div :class="nav == 6 ? 'child active':'child'">
                          小工具
                      </div>
                  </a>


                  <a href="cms.html" v-if="userLlfdType != 2">
                      <div class="child-2">
                          CMS网站推广
                      </div>
                  </a>

                  <a href="mg.html" v-if="userLlfdType != 2">
                      <div class="child-2 size">
                          美逛APP推广
                      </div>
                  </a>
              </div>
          </nav>
        </template>
    </div>

</template>

<script>
    import getCookie from '../../assets/js/cookie'
    import axios from '../../assets/js/request'
    import Cookies from 'js-cookie'
    export default {
        data() {
            return {
                status: null,
                userName: '',
                inputValue: '',
                jsonStr: {},
                erweimaShow: false,
                userLlfdType: 1,
                APPType: undefined
            }
        },
        props: ['nav', 'IsSearch', 'tool', 'isOnlyNav'],
        methods: {
            toLogin() {
                let href = location.href;
                if (this.status === 0) {
                    window.location.href = 'login.html#/redirectUrl=' + encodeURIComponent(href) + '&status=0'
                } else {
                    window.location.href = 'login.html#/redirectUrl=' + encodeURIComponent(href) + '&status=1'
                }
            },
            toSearch() {
                if (this.inputValue.trim()) {
                    if (this.IsSearch) {
                        window.location.href = 'search.html#keyword=' + encodeURIComponent(this.inputValue)
                        window.location.reload();
                    } else {
                        window.location.href = 'search.html#keyword=' + encodeURIComponent(this.inputValue)
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: '请输入关键词搜索',
                        type: 'error'
                    });
                }
            },
            // 登录检测
            login() {
                let href = location.href;
                this.$confirm('您还未登录, 登录后可以进行操作', '提示', {
                    confirmButtonText: '登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    window.location.href = 'login.html#/redirectUrl=' + encodeURIComponent(href)
                }).catch(() => {

                });
            },
            // 登出
            logOut() {
                axios({
                    url: '/api/u/loginout',
                    method: 'get'
                }).then(res => {
                    this.getUserName();
                    this.$parent.getUserState();
                    window.location.reload();
                    // 清除第一次登录标识的cookie
                    Cookies.remove('isFirstLogin');
                })
            },
            // 获取用户名
            getUserName() {
                let userName = '_zutuanweb_nick';
                if (!getCookie(userName)) {
                    this.userName = ''
                } else {
                    this.userName = getCookie(userName);
                }
            },
            // 去个人中心
            goUser(){
                const { userName, userLlfdType, APPType } = this
                if(userName){
                    if(userLlfdType == 2){ // 放单
                        window.open('/user/index.html#/fd_center/fangdan')
                    }else if(APPType === 4){ // 未购买APP跳购买
                        window.open('/user/index.html#/appbuyCommon')
                    }else{
                        window.open('/user/index.html#/home')
                    }
                }else{
                    this.login()
                }
            },
            // 是否未购买App
            checkBuyApp(){
                axios({
                    url: '/api/u/appset/getappsetinfo',
                    method: 'get',
                    params: {
                        oauth: 1,
                        apppay: 1
                    }
                }).then(res => {
                    const { appPay } = res.data
                    if(appPay){
                        this.APPType = appPay.APPType
                    }
                })
            }
        },
        mounted() {
            this.jsonStr.Url = location.href;
        },
        created() {
            this.getUserName()
            if(this.userName){
                this.userLlfdType = Cookies.get('_zutuanweb_tktype') || 1
                if(this.userLlfdType == 1 || this.userLlfdType == 3){
                    this.erweimaShow = true
                }
                this.checkBuyApp()
            }
        },
    }
</script>

<style src="./css/Header.css" scoped></style>
